import { render, staticRenderFns } from "./AvisoCadastro.vue?vue&type=template&id=737f5f27&"
import script from "./AvisoCadastro.vue?vue&type=script&lang=js&"
export * from "./AvisoCadastro.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/avisoCadastro.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports